import { render, staticRenderFns } from "./JobCardAdminOverlay.vue?vue&type=template&id=1972390d&scoped=true&"
import script from "./JobCardAdminOverlay.vue?vue&type=script&lang=js&"
export * from "./JobCardAdminOverlay.vue?vue&type=script&lang=js&"
import style0 from "./JobCardAdminOverlay.vue?vue&type=style&index=0&id=1972390d&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1972390d",
  null
  
)

export default component.exports